import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const FechaInicioFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='F. INICIO' htmlFor='date-fechaInicio' md={3} alignRightAt='md' />
      <Col md={9}>
        <Field name='fechaInicio'>
          {({ field }) => <Form.InputDate {...field} id='date-fechaInicio' disabled={fIsSubmitting} isInvalid={iTouched && iError} />}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(FechaInicioFormGroup)
